import microuniversoApi from "app/api/microuniversoApi";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { useAppSelector } from "app/redux/hooks";
import { atualizarItensAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store";
import { IOrcamento } from "app/types/IOrcamento";
import { DadosTabelaProdutosForaEstoque } from "app/types/produto/ProdutoForaEstoque";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { ProdutosForaEstoqueSelecionados } from "./produtos-fora-estoque-selecionados/ProdutosForaEstoqueSelecionados";
import { FiltrosObterProdutosForaEstoque, ProdutosForaEstoque } from "./ProdutosForaEstoque";

export type ProdutosForaEstoqueContainerProps = {
    onVoltar: () => void,
    orcamentoForaModuloVendas: boolean
    passos: Dict<string, () => void>
    regiaoRenderizada: string
}

export const ProdutosForaEstoqueContainer = (props: ProdutosForaEstoqueContainerProps) => {
    const isMounted = useRef(true)
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento);
    const [dadosProdutosForaEstoque, setDadosProdutosForaEstoque] = useState<PagedMessageResponse<DadosTabelaProdutosForaEstoque>>()
    const [produtosSelecionados, setProdutosSelecionados] = useState<DadosTabelaProdutosForaEstoque[]>([])
    const [processando, setProcessando] = useState(false)

    const filtrosIniciaisObterProdutosForaEstoque: FiltrosObterProdutosForaEstoque = {
        NumeroPagina: 1,
        TamanhoPagina: 20,
        Codigo: "",
        Descricao: "",
        Ordem: "CODIGO"
    }

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

    const validarProdutos = (produtos: DadosTabelaProdutosForaEstoque[]): boolean => {
        const erros: string[] = [];
        
        let retorno = true
        produtos.forEach((produto, index) => {
            if (!produto.Descricao || produto.Descricao.trim() === '') {
                globalMU.showErrorMessage(`Produto [${produto.Codigo}]: Descrição é obrigatória`)
                retorno = false
            }
            if (!produto.PrecoUnitario || produto.PrecoUnitario <= 0) {
                globalMU.showErrorMessage(`Produto [${produto.Codigo}]: Preço deve ser maior que zero`)
                 retorno = false
            }
            if (!produto.Quantidade || produto.Quantidade <= 0) {
                globalMU.showErrorMessage(`Produto [${produto.Codigo}]: Quantidade deve ser maior que zero`)
                 retorno = false
            }
        })
        return retorno
    }

    const onProdutosForaEstoque = async () => {
        globalMU.blockUI();
        try {
            if (!isMounted.current) return
            const data = await microuniversoApi.Produto.produtosForaEstoque();

            if (isMounted.current) {
                setDadosProdutosForaEstoque(data);
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    };

    const onPesquisar = async (filtrosObterProdutosForaEstoque: FiltrosObterProdutosForaEstoque) => {
        globalMU.blockUI();
        try {
            if (!isMounted.current) return
            const data = await microuniversoApi.Produto.obterProdutosForaEstoque(filtrosObterProdutosForaEstoque);
            if (isMounted.current) {
                setDadosProdutosForaEstoque(data);
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    };

    const onAplicar = async (dadosTabelaProdutosForaEstoque: DadosTabelaProdutosForaEstoque[]) => {

        globalMU.blockUI();
        setProcessando(true)
        try {
            if (!isMounted.current) return
            // Validar antes de aplicar
            if (!validarProdutos(dadosTabelaProdutosForaEstoque))
                return
            
            if (!isMounted.current) return
            var result = await microuniversoApi.Orcamento.adicionarProdutosForaEstoque(orcamento.IdentificadorOrcamento, dadosTabelaProdutosForaEstoque);
            if (!isMounted.current) return
            if (result && !("HasErrors" in result)) {
                const itens  = result.ItensOrcamento
                store.dispatch(sobrescreverInformacoesAction(result))
                const valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL = store.getState().parametros?.["ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL"]
                store.dispatch(atualizarItensAction({ itens, acao: "SOBRESCREVER", corPorAmbiente: store.getState().corPorAmbiente, valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL }))
                passosInterno.current.get("Itens")()
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            setProcessando(false)
            globalMU.unblockUI();
        }
    }

    const onPassoSelecionado = (passo: string) => {
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onVoltar()
    }

    const handleSetProdutosSelecionados = (produtos: DadosTabelaProdutosForaEstoque[]) => {
        if (isMounted.current) {
            setProdutosSelecionados(produtos);
        }
    }

    useEffect(() => {
        passosInterno.current.set("Produtos Fora de Estoque", () => { })
        onProdutosForaEstoque();
        return () => {
            isMounted.current = false;
        }
    }, [])

    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
                id="ProdutosForaEstoqueContainer"
            />
            {produtosSelecionados.length == 0 ?
                <ProdutosForaEstoque
                    dadosProdutosForaEstoque={dadosProdutosForaEstoque}
                    filtrosObterProdutosForaEstoque={filtrosIniciaisObterProdutosForaEstoque}
                    numeroTotalPaginas={dadosProdutosForaEstoque?.PageCount}
                    paginaAtual={dadosProdutosForaEstoque?.ActualPage}
                    onAlterarListaSelecionada={onPesquisar}
                    onOk={handleSetProdutosSelecionados}
                    onPesquisar={onPesquisar}
                    corSelecionado={globalMU.sessionStorage.getData("UsuarioLogado")?.CorFundo}
                    textoSelecionado={globalMU.sessionStorage.getData("UsuarioLogado")?.CorTexto}
                />
                : <ProdutosForaEstoqueSelecionados
                    orcamentoForaModuloVendas={props.orcamentoForaModuloVendas}
                    processando={processando}
                    onAplicar={onAplicar}
                    dadosTabelaProdutosForaEstoque={produtosSelecionados}
                />}
        </>
    )
}